import { siteConfig } from "@/config/site.config";

/**
 * Build a wa.me URL with a URL-encoded prefilled message.
 * @param {string} message
 * @returns {string}
 */
export function buildWhatsAppUrl(message) {
    const base = `https://wa.me/${siteConfig.whatsappNumber}`;
    if (!message) return base;
    return `${base}?text=${encodeURIComponent(message)}`;
}

export const defaultEnquiryMessage =
    "Hello Container Specialist, I would like to enquire about your containers. Please assist me with the available options and pricing.";

export const customEnquiryMessage =
    "Hello Container Specialist, I am interested in a customised container. I would like to discuss the required size, intended use and modifications.";

/**
 * Product-specific message generator — used on product cards and detail pages.
 * @param {{name:string, referenceNumber:string}} product
 */
export function productEnquiryMessage(product) {
    if (!product) return defaultEnquiryMessage;
    return `Hello Container Specialist, I would like to enquire about ${product.name}, reference ${product.referenceNumber}. Please provide the current availability and pricing.`;
}

export const quickEnquiryPresets = [
    {
        id: "new",
        label: "Enquire About New Containers",
        message:
            "Hello Container Specialist, I would like to enquire about new containers. Please share the available sizes and current availability.",
    },
    {
        id: "used",
        label: "Enquire About Used Containers",
        message:
            "Hello Container Specialist, I would like to enquire about used containers. Please share the available sizes, condition and current availability.",
    },
    {
        id: "custom",
        label: "Discuss a Customised Container",
        message: customEnquiryMessage,
    },
    {
        id: "availability",
        label: "Check Current Availability",
        message:
            "Hello Container Specialist, could you please share the current container availability for my requirements?",
    },
    {
        id: "pricing",
        label: "Request Container Pricing",
        message:
            "Hello Container Specialist, I would like to request current pricing for containers. Please advise on the available options.",
    },
];
